import React, {Suspense} from 'react';
import WebGLContainer from 'components/webgl/WebGLContainer';
import Spinner from 'components/Spinner';
import AnimationButtons from 'components/AnimationButtons';

const App = () => {
  return (
    <div className="app">
      <Suspense fallback={<Spinner/>}>
        <WebGLContainer/>
        <AnimationButtons/>
      </Suspense>
    </div>
  );
};

export default App;
